<template>
  <v-slide-x-transition>
    <div v-if="feature">
      <v-textarea
        v-model="like"
        autofocus
        class="mx-3 pt-4"
        clearable
        @keyup.ctrl.enter="setItemsPagination({ pagination: { page: 1 } })"
        label="Patrón LIKE"
        prepend-icon="check"
      />
      <v-textarea
        v-model="notLike"
        class="mx-3"
        clearable
        @keyup.ctrl.enter="setItemsPagination({ pagination: { page: 1 } })"
        label="Patrón NOT LIKE"
        prepend-icon="clear"
      />
    </div>
  </v-slide-x-transition>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";

export default {
  computed: {
    ...mapState("featureRules", ["feature", "likePattern"]),
    like: {
      get() {
        return this.likePattern.like;
      },
      set(value) {
        this.setLikePattern({
          ...this.likePattern,
          like: value ? value.replace(/\n/g, " ").trim() : value
        });
      }
    },
    notLike: {
      get() {
        return this.likePattern.notLike;
      },
      set(value) {
        this.setLikePattern({
          ...this.likePattern,
          notLike: value ? value.replace(/\n/g, " ").trim() : value
        });
      }
    }
  },
  methods: {
    ...mapMutations("featureRules", ["setLikePattern"]),
    ...mapActions("featureRules", ["setItemsPagination"])
  }
};
</script>
